import { getAllAnswers } from '@/utils/onboardingStorage'
import { getSession, supabase } from '@app-studio-web/ui/helpers/supabase'
import * as Sentry from '@sentry/react'

export async function saveOnboardingAnswers() {
  try {
    const { data: sessionData } = await getSession()
    const userId = sessionData?.session?.user?.id

    if (!userId) {
      console.error('saveOnboardingAnswers: No user ID found')
      return { success: false }
    }

    const onboardingAnswers = getAllAnswers()

    if (!Object.keys(onboardingAnswers).length) {
      console.error('saveOnboardingAnswers: No onboarding answers found')
      return { success: false }
    }

    const { error } = await supabase
      .schema('bumi')
      .from('onboarding_answers')
      .upsert(
        {
          answers: onboardingAnswers,
          user_id: userId,
        },
        { onConflict: 'user_id' },
      )

    if (error) {
      console.error('saveOnboardingAnswers: Supabase error', error)
      Sentry.captureException(error)
      return { success: false }
    }

    return { success: true }
  } catch (error) {
    console.error('saveOnboardingAnswers: Unexpected error', error)
    Sentry.captureException(error)
    return { success: false }
  }
}
